import XEUtils from 'xe-utils'
// 日期格式化
export function ykDateFormat(fmt, str) {
  if (!str) {
    return ''
  }
  var date = new Date(str)
  if (!date) {
    return ''
  }
  if (date.getFullYear() === 1900) {
    return ''
  } else {
    return XEUtils.toDateString(str, fmt)
  }
}

// table 移除空行
export function removeEmptyForTable(table, defaultArray = []) {
  let tableData = table.getTableData().fullData
  for (let row of tableData) {
    let ifRemove = true
    for (let key in row) {
      if (key !== '_XID' && !defaultArray.includes(key)) {
        if (row[key] !== null) {
          ifRemove = false
          break
        }
      }
    }
    if (ifRemove) {
      table.remove(row)
    }
  }
}

// 移除数组为null,''的属性
export function removeArrayNull(array) {
  for (let obj of array) {
    Object.keys(obj).forEach((item) => {
      if (!obj[item]) {
        delete obj[item]
      }
    })
  }
  return array
}
// 移除对象为null,''的属性
export function removeObjectNull(obj) {
  let copy = JSON.parse(JSON.stringify(obj))
  Object.keys(copy).forEach((item) => {
    if (!copy[item]) {
      delete copy[item]
    }
  })
  return copy
}
